<template>
  <header class="topnav">
    <div class="topnav__inner">

      <!-- Left: social icons (always visible for balance) -->
      <div class="topnav__left">
        <a href="https://www.linkedin.com/in/dixit-prajapati" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" class="topnav__social-link">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>
        </a>
        <a href="https://github.com/DixitPrajapatii" target="_blank" rel="noopener noreferrer" aria-label="GitHub" class="topnav__social-link">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0 1 12 6.844a9.59 9.59 0 0 1 2.504.337c1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.02 10.02 0 0 0 22 12.017C22 6.484 17.522 2 12 2z"/></svg>
        </a>
        <a href="https://medium.com/@dixitofficial98" target="_blank" rel="noopener noreferrer" aria-label="Medium" class="topnav__social-link">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M13.54 12a6.8 6.8 0 01-6.77 6.82A6.8 6.8 0 010 12a6.8 6.8 0 016.77-6.82A6.8 6.8 0 0113.54 12zm7.42 0c0 3.54-1.51 6.42-3.38 6.42-1.87 0-3.39-2.88-3.39-6.42s1.52-6.42 3.39-6.42 3.38 2.88 3.38 6.42M24 12c0 3.17-.53 5.75-1.19 5.75-.66 0-1.19-2.58-1.19-5.75s.53-5.75 1.19-5.75C23.47 6.25 24 8.83 24 12z"/></svg>
        </a>
      </div>

      <!-- Center: nav links — absolutely centered so it's always in the middle regardless of side content -->
      <nav class="topnav__nav" aria-label="Main navigation">
        <ul>
          <li v-for="(link, idx) in navLinks" :key="link.id">
            <span v-if="idx > 0" class="topnav__sep" aria-hidden="true">•</span>
            <button
              :class="['topnav__link', { 'topnav__link--active': activeSection === link.id }]"
              @click="scrollTo(link.id)"
            >
              {{ link.label }}
            </button>
          </li>
        </ul>
      </nav>

      <!-- Right: badge + hamburger -->
      <div class="topnav__right">
        <div class="topnav__badge">
          <span class="topnav__badge-dot"></span>
          Open to Work
        </div>
        <button
          class="topnav__toggle"
          @click="isOpen = !isOpen"
          :aria-expanded="isOpen"
          aria-label="Toggle menu"
        >
          <span :class="['hamburger', { 'hamburger--open': isOpen }]">
            <span></span><span></span><span></span>
          </span>
        </button>
      </div>
    </div>

    <!-- Mobile / tablet dropdown -->
    <Transition name="menu-drop">
      <div v-if="isOpen" class="topnav__dropdown">
        <ul>
          <li v-for="link in navLinks" :key="link.id">
            <button
              :class="['topnav__dropdown-link', { 'topnav__dropdown-link--active': activeSection === link.id }]"
              @click="scrollTo(link.id)"
            >
              <span class="topnav__dropdown-icon" v-html="link.icon"></span>
              {{ link.label }}
            </button>
          </li>
        </ul>

        <!-- Social row inside dropdown on mobile -->
        <div class="topnav__dropdown-social">
          <a href="https://www.linkedin.com/in/dixit-prajapati" target="_blank" rel="noopener noreferrer" class="topnav__social-link">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>
          </a>
          <a href="https://github.com/DixitPrajapatii" target="_blank" rel="noopener noreferrer" class="topnav__social-link">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0 1 12 6.844a9.59 9.59 0 0 1 2.504.337c1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.02 10.02 0 0 0 22 12.017C22 6.484 17.522 2 12 2z"/></svg>
          </a>
          <a href="https://medium.com/@dixitofficial98" target="_blank" rel="noopener noreferrer" class="topnav__social-link">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M13.54 12a6.8 6.8 0 01-6.77 6.82A6.8 6.8 0 010 12a6.8 6.8 0 016.77-6.82A6.8 6.8 0 0113.54 12zm7.42 0c0 3.54-1.51 6.42-3.38 6.42-1.87 0-3.39-2.88-3.39-6.42s1.52-6.42 3.39-6.42 3.38 2.88 3.38 6.42M24 12c0 3.17-.53 5.75-1.19 5.75-.66 0-1.19-2.58-1.19-5.75s.53-5.75 1.19-5.75C23.47 6.25 24 8.83 24 12z"/></svg>
          </a>
        </div>
      </div>
    </Transition>
  </header>

  <!-- Overlay -->
  <Transition name="fade">
    <div v-if="isOpen" class="nav-overlay" @click="isOpen = false" />
  </Transition>
</template>

<script setup>
import { ref, inject } from 'vue'

const isOpen = ref(false)

const navigateTo = inject('navigateTo', () => {})
const activeSection = inject('activeSection', ref('hero'))

const navLinks = [
  { id: 'hero',           label: 'Home',    icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>' },
  { id: 'about',          label: 'About',   icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>' },
  { id: 'skills',         label: 'Skills',  icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>' },
  { id: 'resume',         label: 'Resume',  icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>' },
  { id: 'certifications', label: 'Certs',   icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/></svg>' },
  { id: 'testimonials',   label: 'Reviews', icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>' },
  { id: 'contact',        label: 'Contact', icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>' },
]

function scrollTo(id) {
  navigateTo(id)
  isOpen.value = false
}
</script>

<style scoped>
/* ═══════════════════════════════════════
   NAV BAR SHELL
═══════════════════════════════════════ */
.topnav {
  position: fixed;
  top: 0; left: 0; right: 0;
  height: 64px;
  background: rgba(4, 4, 10, 0.9);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-bottom: 1px solid var(--color-border);
  z-index: 999;
}

/*
  3-column grid:
    left  = social icons  (fixed size, anchored left)
    center= nav links     (takes remaining space, content centered)
    right = badge + toggle(fixed size, anchored right)

  Using grid instead of flex ensures the center column is
  always perfectly symmetric regardless of side widths.
*/
.topnav__inner {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  height: 100%;
  padding: 0 36px;
}

/* ═══════════════════════════════════════
   LEFT — social icons
═══════════════════════════════════════ */
.topnav__left {
  display: flex;
  align-items: center;
  gap: 4px;
  justify-self: start;
}

.topnav__social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px; height: 32px;
  border-radius: var(--radius-xs);
  background: var(--color-bg-card);
  border: 1px solid var(--color-border);
  color: rgba(255, 255, 255, 0.45);
  transition: var(--transition);
  text-decoration: none;
}
.topnav__social-link:hover {
  color: var(--color-accent);
  border-color: var(--color-border-accent);
  background: rgba(var(--color-accent-rgb), 0.08);
  transform: translateY(-1px);
}

/* ═══════════════════════════════════════
   CENTER — nav links
═══════════════════════════════════════ */
.topnav__nav {
  display: flex;
  justify-content: center;
}

.topnav__nav ul {
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0; padding: 0;
  flex-wrap: nowrap;
}

.topnav__sep {
  color: rgba(255, 255, 255, 0.18);
  font-size: 9px;
  margin: 0 12px;
  pointer-events: none;
  user-select: none;
  flex-shrink: 0;
}

.topnav__link {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #ffffff;
  padding: 6px 2px;
  position: relative;
  transition: var(--transition);
  white-space: nowrap;
  background: none;
  border: none;
  cursor: pointer;
  font-family: var(--font-sans);
}
.topnav__link::after {
  content: '';
  position: absolute;
  bottom: 0; left: 0; right: 0;
  height: 1px;
  background: var(--color-accent);
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.22s ease;
}
.topnav__link:hover            { color: var(--color-accent); }
.topnav__link:hover::after     { transform: scaleX(1); }
.topnav__link--active          { color: var(--color-accent); }
.topnav__link--active::after   { transform: scaleX(1); }

/* ═══════════════════════════════════════
   RIGHT — badge + toggle
═══════════════════════════════════════ */
.topnav__right {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-self: end;
}

/* Badge */
.topnav__badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 500;
  color: #4ade80;
  background: rgba(74, 222, 128, 0.1);
  border: 1px solid rgba(74, 222, 128, 0.2);
  padding: 4px 10px;
  border-radius: 100px;
  white-space: nowrap;
}
.topnav__badge-dot {
  width: 6px; height: 6px;
  background: #4ade80;
  border-radius: 50%;
  flex-shrink: 0;
  animation: pulse-dot 2s ease-in-out infinite;
}
@keyframes pulse-dot {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.4; }
}

/* Hamburger toggle */
.topnav__toggle {
  display: none;
  padding: 6px;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  flex-shrink: 0;
}
.hamburger { display: flex; flex-direction: column; gap: 5px; width: 22px; }
.hamburger span {
  display: block;
  height: 2px;
  background: #ffffff;
  border-radius: 1px;
  transition: var(--transition);
}
.hamburger--open span:nth-child(1) { transform: translateY(7px) rotate(45deg); }
.hamburger--open span:nth-child(2) { opacity: 0; }
.hamburger--open span:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }

/* ═══════════════════════════════════════
   MOBILE / TABLET DROPDOWN
═══════════════════════════════════════ */
.topnav__dropdown {
  position: absolute;
  top: 100%;
  left: 0; right: 0;
  background: rgba(4, 4, 10, 0.98);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border-bottom: 1px solid var(--color-border);
  padding: 8px 16px 20px;
  z-index: 998;
}
.topnav__dropdown ul {
  display: flex;
  flex-direction: column;
  gap: 2px;
  list-style: none;
  padding: 0; margin: 0;
}

.topnav__dropdown-link {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 11px 14px;
  border-radius: var(--radius-sm);
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  background: none;
  border: none;
  cursor: pointer;
  font-family: var(--font-sans);
  transition: var(--transition);
}
.topnav__dropdown-icon {
  opacity: 0.5;
  flex-shrink: 0;
  color: var(--color-text-secondary);
  display: flex;
  align-items: center;
}
.topnav__dropdown-link:hover {
  background: var(--color-bg-card);
  color: #ffffff;
}
.topnav__dropdown-link--active {
  color: var(--color-accent);
  background: rgba(var(--color-accent-rgb), 0.08);
}
.topnav__dropdown-link--active .topnav__dropdown-icon {
  opacity: 1;
  color: var(--color-accent);
}

/* Social row inside dropdown */
.topnav__dropdown-social {
  display: flex;
  gap: 8px;
  padding: 12px 14px 0;
  border-top: 1px solid var(--color-border);
  margin-top: 8px;
}

/* ═══════════════════════════════════════
   OVERLAY
═══════════════════════════════════════ */
.nav-overlay {
  position: fixed; inset: 0;
  z-index: 997;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
}

/* ═══════════════════════════════════════
   TRANSITIONS
═══════════════════════════════════════ */
.menu-drop-enter-active, .menu-drop-leave-active { transition: opacity 0.22s ease, transform 0.22s ease; }
.menu-drop-enter-from, .menu-drop-leave-to       { opacity: 0; transform: translateY(-8px); }

.fade-enter-active, .fade-leave-active { transition: opacity 0.22s ease; }
.fade-enter-from, .fade-leave-to       { opacity: 0; }

/* ═══════════════════════════════════════
   RESPONSIVE BREAKPOINTS
═══════════════════════════════════════ */

/* Large desktop — full layout, generous dot spacing */
@media (min-width: 1281px) {
  .topnav__sep { margin: 0 14px; }
}

/* Medium desktop — tighten dots slightly */
@media (max-width: 1280px) {
  .topnav__inner { padding: 0 24px; }
  .topnav__sep { margin: 0 10px; }
  .topnav__badge { display: none; }
}

/* Tablet — hide nav links, show hamburger; social stays on left */
@media (max-width: 1024px) {
  .topnav__nav    { display: none; }
  .topnav__toggle { display: flex; }
  /* Switch to simple flex — no brand means left/right split is fine */
  .topnav__inner {
    grid-template-columns: auto 1fr auto;
  }
}

/* Mobile — tighten padding, smaller social icons */
@media (max-width: 640px) {
  .topnav__inner { padding: 0 16px; }
  .topnav__social-link { width: 30px; height: 30px; }
  .topnav__dropdown { padding: 6px 12px 16px; }
  .topnav__dropdown-link { font-size: 13px; padding: 10px 12px; }
}

/* Very small — single column dropdown, tightest padding */
@media (max-width: 360px) {
  .topnav__inner { padding: 0 12px; }
  .topnav__social-link { width: 28px; height: 28px; }
}
</style>
